import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { BuyerContract, BuyerContractClient, BuyerContractDetail, Profile, ThresholdBuyerContract } from './models/BuyerContract';
import { DateTerm } from "./models/DateTerm";
import { PaymentInfo } from "./models/Payment";
import { PricingProfile, ProfileUpgrade, ProfileUpgradeDetail, ProfileUpgradeRich, ShoppingElement } from "./models/Pricing";

export default class BuyerContractVuexModule extends AbacoVuexModule {

    @State() curBuyerContract!: BuyerContract | null;
    @State() curBuyerContractDetail!: BuyerContractDetail | null;
    @State() curContract!: ThresholdBuyerContract | null;
    @State() curClient!: BuyerContractClient | null;
    @State() curProfile!: Profile | null;
    @State() curDateTerm!: DateTerm | null;
    @State() curContractPkid!: number | null;
    @State() paymentDetail!: PaymentInfo | null;
    @State({default: []}) pricingProfiles!: PricingProfile[];
    @State({default: []}) pricingProfileUpgrades!: ProfileUpgradeRich[];
    @State({default: null}) shoppingCart!: ProfileUpgrade | null;
}
